import { TextButton, type TypeTextButtonProps } from '@thefarmersfront/kitchen';

import type { IRowNode } from 'ag-grid-community';
import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from './TableCellRenderer.module.scss';

export type TypeTextButtonCellParams<TData> = {
  variant?: TypeTextButtonProps['variant'];
  weight?: TypeTextButtonProps['weight'];
  disabled?: TypeTextButtonProps['disabled'];
  children: TypeTextButtonProps['children'];
  target?: TypeTextButtonProps['target'];
  href?: TypeTextButtonProps['href'];
  rightIcon?: TypeTextButtonProps['rightIcon'];
  /**
   * 값이 없을 경우 대시(-)로 표시할지 여부
   * @default true
   */
  showDashIfNoValue?: boolean;
  onClick: (node: IRowNode<TData>) => Promise<void> | void;
};

export type TypeTextButtonCellProps<TData, TValue> = TypeTextButtonCellParams<TData> &
  CustomCellRendererProps<TData, TValue>;

const TextButtonCell = <TData, TValue>({
  variant = 'underline',
  weight = 'semi-bold',
  disabled = false,
  value,
  children,
  target,
  href,
  rightIcon,
  showDashIfNoValue = true,
  onClick,
  ...params
}: TypeTextButtonCellProps<TData, TValue>) => {
  const handleClick = () => {
    if (!disabled) {
      onClick?.(params.node);
    }
  };

  if (showDashIfNoValue && (!value || (Array.isArray(value) && value.length === 0))) return '-';

  return (
    <TextButton
      className={styles['text-button-cell']}
      size="tiny"
      variant={variant}
      weight={weight}
      disabled={disabled}
      onClick={handleClick}
      target={target}
      href={href}
      rightIcon={rightIcon}
    >
      {children}
    </TextButton>
  );
};

export default TextButtonCell;
